import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(e.target as Node)) {
        setIsMobileMenuOpen(false);
      }
    };
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category/dianying', label: '电影' },
    { path: '/category/dianshiju', label: '电视剧' },
    { path: '/category/zongyi', label: '综艺' },
    { path: '/category/dongman', label: '动漫' },
    { path: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-foreground-50 text-xl"></i>
            </div>
            <span className="text-xl font-bold text-foreground-50 font-heading tracking-wide">
              樱桃视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400 font-medium'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center bg-background-200/60 rounded-full px-4 py-2 gap-2 border border-background-300/40">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="bg-transparent text-sm text-foreground-200 placeholder:text-foreground-500 outline-none w-40 border-none"
              />
            </div>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 border border-background-300/40 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-foreground-50 text-lg`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div ref={mobileMenuRef} className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            <div className="flex items-center bg-background-200/60 rounded-lg px-4 py-3 gap-2 mb-2 border border-background-300/40">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="bg-transparent text-sm text-foreground-200 placeholder:text-foreground-500 outline-none flex-1 border-none"
              />
            </div>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 text-sm rounded-lg transition-all duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400 font-medium'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}